import { Component }  from 'react';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import { setIdToken, 
         setAccessToken, 
         setRefreshToken,
         callback,
         isAccessToken } from '../../../utils/authService';

class Callback extends Component {

  componentDidMount() {  
    if (isAccessToken()) {
      setAccessToken();
      setIdToken();
      setRefreshToken();
      callback();
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({ 

});

export default withRouter(connect(mapStateToProps)(Callback));
